module.exports = __webpack_public_path__ + "img/journey.04fbda5a.webp";